var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.0026C14.6673 11.6845 11.6826 14.6693 8.00065 14.6693M14.6673 8.0026C14.6673 4.32071 11.6826 1.33594 8.00065 1.33594M14.6673 8.0026H1.33398M8.00065 14.6693C4.31875 14.6693 1.33398 11.6845 1.33398 8.0026M8.00065 14.6693C9.66817 12.8437 10.6158 10.4746 10.6673 8.0026C10.6158 5.53063 9.66817 3.16151 8.00065 1.33594M8.00065 14.6693C6.33313 12.8437 5.38548 10.4746 5.33398 8.0026C5.38548 5.53063 6.33313 3.16151 8.00065 1.33594M1.33398 8.0026C1.33398 4.32071 4.31875 1.33594 8.00065 1.33594",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4a6bd2953f846001b37059b66c59b299.svg";
export { ForwardRef as ReactComponent };